import BuildingsInformation from "../../../Components/Admin/Buildings/BuildingsInformation/BuildingInformation";
import { getAllLockProviders } from "../../../Redux/Buildings/BuildingActions";
import Members from "../../../Components/Admin/Buildings/Members/Members";
import { getAllGroups } from "../../../Redux/Groups/GroupsActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import React, { useEffect, useState } from "react";
import styles from "./AddBuilding.module.scss";
import { Link } from "react-router";

function AddBuilding() {
  const [activeTab, setActiveTab] = useState("buildingInformation");
  const dispatch = useDispatch<AppDispatch>();
  const { profileLoading } = useSelector((state: RootState) => state.profile);
  const { createBuilding } = useSelector((state: RootState) => state.buildings);
  const tabs = [
    {
      label: "Building Information",
      value: "buildingInformation",
    },
    {
      label: "Members",
      value: "members",
    },
  ];
  const tabsRenderer = () => {
    return (
      <React.Fragment>
        <div className={styles.tabsContainer}>
          {tabs.map((tab, i) => (
            <div
              key={i}
              className={
                activeTab === tab.value ? styles.activeTab : styles.tab
              }
            >
              <p>{tab.label}</p>
            </div>
          ))}
        </div>
        <div className={styles.tabContent}>
          {activeTab === "buildingInformation" && (
            <BuildingsInformation
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              buildingId={createBuilding?.buildingId || ""}
            />
          )}
          {activeTab === "members" && (
            <Members
              setActiveTab={setActiveTab}
              buildingId={createBuilding?.buildingId || ""}
            />
          )}
        </div>
      </React.Fragment>
    );
  };

  useEffect(() => {
    // dispatch(getProfile());
    dispatch(getAllLockProviders());
    dispatch(getAllGroups());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (profileLoading) {
    return <Loading />;
  }

  return (
    <div className={styles.mainContainer}>
      <Link
        to="/admin/buildings"
        replace
        className={styles.backButtonContainer}
      >
        <button className={styles.button}>
          <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
          Back to Buildings
        </button>
      </Link>
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Add Building</p>
      </div>
      <div className={styles.bodyContainer}>
        <div className={styles.tabsContainer}>{tabsRenderer()}</div>
      </div>
    </div>
  );
}

export default AddBuilding;
